import React from "react"
import Genre from "../../fixtures/genre.json"

import { Footer, Icon } from "../../components"
import { Link } from "react-router-dom"

export default function FooterSection() {
  return (
    <div>
      <Footer>
        <Footer.Logo />
        <Footer.Content>
          <Footer.Item>
            <Footer.Title>Popular Genre</Footer.Title>
            <Footer.Body>
              {Genre.map((item) => {
                return (
                  <Footer.FLink key={item.id} to={`/genre/${item.id}/movie`}>
                    {item.name}
                  </Footer.FLink>
                )
              })}
            </Footer.Body>
          </Footer.Item>
          <Footer.Item>
            <Footer.Title>Designed By</Footer.Title>
            <Footer.Body>
              <Footer.Text>~ Vinay Bhadre</Footer.Text>
              <Footer.SocialHandle />
            </Footer.Body>
          </Footer.Item>
          <Footer.Item>
            <Footer.Title>Credit</Footer.Title>
            <Footer.Body>
              <Footer.Text>
                I am really thankful to the team of{" "}
                <Link target="_blank" to={{ pathname: "//www.themoviedb.org/" }}>
                  Themoviedb.org
                </Link>
                . For their effortless and awesome API.
              </Footer.Text>
            </Footer.Body>
          </Footer.Item>
          <Footer.Item>
            <Footer.Title>
              Thank You <Icon name="ph-heart-fill" size="18" color="#38BDF8" />
            </Footer.Title>
            <Footer.Body>
              <Link target="_blank" to={{ pathname: "//www.themoviedb.org/" }}>
                <Footer.TMDBLogo />
              </Link>
            </Footer.Body>
          </Footer.Item>
        </Footer.Content>
      </Footer>
      <Footer.Copyright>
        <Footer.Text>© 2020 TheMovieBase, All rights reserved.</Footer.Text>
        <Footer.Text>
          Made with <Icon name="ph-heart-fill" size="18" color="#fff" /> By <span>Vinay</span>
        </Footer.Text>
        <Footer.Text>Tearm and Condition | Privacy Policy | FAQ</Footer.Text>
      </Footer.Copyright>
    </div>
  )
}
